import Modal from "~/common/components/Modal";
import { Button, Typography } from "@schaeffler-commerce/design-system";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

export const LmsNotApprovedModal = (props: Props) => {
  const isMinTablet = useIsMinTabletSize();
  const { t } = useTranslation();
  return (
    <Modal
      onClose={props.onClose}
      footerChildren={<Button onClick={props.onConfirm}>{t("feature.lms.modal.button.ok")}</Button>}
    >
      <Typography variant="titleMedium" sx={{ display: "block", margin: 0, pb: 4 }}>
        <Trans i18nKey="feature.lms.modal.not_approved.text" />
      </Typography>
    </Modal>
  );
};
